import { Form } from 'antd';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useGetActivityOptions } from '@/hooks/v2/useGetActivityOptions';

interface ActivityProps {
	fieldName?: string | string[];
}

const { useFormInstance, useWatch } = Form;

export function useActivity({ fieldName }: ActivityProps) {
	const form = useFormInstance();
	const { organization, company } = useApplicationContext();

	const field = Array.isArray(fieldName) ? fieldName[0] : null;

	const workstationId = useWatch(field ? [field, 'workstation_id'] : 'workstation_id');
	const activityId = useWatch(field ? [field, 'activity_id'] : 'activity_id');

	const {
		isFetching,
		data: activities,
		isError
	} = useGetActivityOptions({
		organization_id: organization.id!,
		company_id: company.id!,
		workstation_id: workstationId
	});

	const isDisabled = !workstationId;

	function handleSelectActivity(id: string): void {
		form.setFieldValue(field ? [field, 'activity_id'] : ['activity_id'], id);
	}

	function handleClearActivity(): void {
		form.setFieldValue(field ? [field, 'activity_id'] : ['activity_id'], undefined);
	}

	return {
		items: activities || [],
		activityId,
		workstationId,
		isFetching,
		isError,
		isDisabled,
		handleSelectActivity,
		handleClearActivity
	};
}
